import { _, allRoles, isAuthorized, lazyLoadView, piloteAndAuditor, requiresInternal, setNavL2 } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'

export const exemptionsRoutes: RouteConfig = {
  path: '/exemptions',
  name: 'exemptions',
  component: () => lazyLoadView(import('@/contexts/exemptions/ExemptionRegistersListView.vue')),
  meta: {
    title: _('Exemptions'),
    icon: 'unlock',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_role: piloteAndAuditor,
    requires_auth: true,
    requires_tenant: true,
    doc_id: 'exemption_register',
    feature_id: 'EXEMPTIONS',
  },
  children: [
    {
      path: ':id',
      name: 'exemption',
      component: () => lazyLoadView(import('@/contexts/exemptions/ExemptionRegisterView.vue')),
      meta: {
        title: null,
        icon: 'unlock',
        is_authorized: (route: Route) => isAuthorized(route),
        requires_role: piloteAndAuditor,
        requires_auth: true,
        requires_tenant: true,
        doc_id: 'exemption',
      },
    },
  ],
}

export const exemptionsContributionRoutes: RouteConfig = {
  path: 'exemptions',
  name: 'myexemptions',
  component: () => lazyLoadView(import('@/contexts/exemptions/ExemptionsContributionView.vue')),
  beforeEnter: setNavL2,
  meta: {
    title: _('Exemptions'),
    icon: 'unlock',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: allRoles,
    requires_internal: () => requiresInternal(),
    doc_id: 'my_exemptions',
    nb_contribution: 'nb_exemptions',
    feature_id: 'EXEMPTIONS',
  },
}
